<!-- @Author: xiaodongyu -->
<!-- @Date: 2024-02-24 17:54:53 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-29 13:28:54 -->

<template>
    <div class="container register-layout">
        <div class="left">
            <register-step
                :step="step"
                class="layout-step"
            />
            <slot />
        </div>
        <div class="right">
            <div class="tip-wrapper">
                <slot name="tip" />
            </div>
        </div>
    </div>
</template>

<script>
import RegisterStep from './register-step';

export default {
    name: 'RegisterLayout',

    components: {
        RegisterStep
    },

    props: {
        step: {
            type: Number,
            default: 1
        }
    },
};
</script>

<style lang="scss" scoped>
.register-layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .left {
        width: 6.3rem;

        .layout-step {
            position: sticky;
            top: 0.75rem;
            left: 1rem;
            z-index: 3;
        }
    }

    .right {
        width: 5.56rem;
        min-height: 8rem;

        .tip-wrapper {
            position: sticky;
            width: 5.56rem;
            height: 7rem;
            max-height: calc(100vh - 2.4rem);
            top: 1rem;
            left: 7.84rem;
            border-radius: 0.16rem;
            background: url("./tip-bg.raw.png") center center / cover no-repeat, linear-gradient(180deg, #2b6c41 0%, #000 100%, #000 100%);
            padding: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: #fff;
        }
    }
}
</style>
